<template>
  <vue-tel-input
      :id="inputFieldId"
      type="text"
      :value="sanitizedValue"
      :required="data.required"
      mode="international"
      :disabled="data.disabled"
      :name="name"
      :placeholder="data.placeholder"
      :inputClasses="data.inputClass + ' default-font-color'"
      defaultCountry="GB"
      @input="sanitizeInput"
      @country-changed="onCountryChanged"
  />
</template>

<script>
import { VueTelInput } from "vue-tel-input";
import { InputMixin } from "./mixin/InputMixin.js";

export default {
  name: "TelInputCustom",
  mixins: [InputMixin],
  components: { VueTelInput },
  data() {
    return {
      sanitizedValue: this.value || "", // Store sanitized value locally
      countryCode: null,
    };
  },
  watch: {
    value(newVal) {
      // Update sanitizedValue if parent prop changes
      this.sanitizedValue = newVal;
    },
  },
  methods: {
    sanitizeInput(rawValue) {
      // Allow only numbers and '+' and strip other characters
      const sanitized = rawValue.replace(/[^+\d]/g, "");

      // Update local state and emit sanitized value
      this.sanitizedValue = sanitized;
      this.$emit("input", sanitized);
    },
    onCountryChanged(country) {
      const _countryCode = "+" + country.dialCode + " ";
      if (this.countryCode) {
        this.sanitizedValue = _countryCode;
        this.$emit("input", _countryCode);
      }
      this.countryCode = _countryCode;
    },
  },
};
</script>
